import { StyleSheet, View } from 'react-native';
import React, { FC, useCallback, useMemo, useState } from 'react';
import { CoachingFormInputs, initValueForm } from '../constanst';
import SportDropDown from './SportDropDown';
import { person } from '../types';
import { ErrorMessage, Field, FieldProps, Formik } from 'formik';
import { IFormData } from '../../../components/FormHelper/FormHelper.types';
import { Text } from '../../../components/Text';
import { Button } from '../../../components/Button';
import { STYLE_VARS } from '../../../constants/style-vars';
import { TextInput } from '../../../components/TextInput/TextInput';
import { FONTS } from '../../../constants';
import WeekDaySelect from './WeekDaySelect';
import * as yup from 'yup';
import SportApi from '../../../services/api/sports.api';
import { Loading } from '../../../components';
import { Alert } from '../../../services/alert';

interface SportCoachingFormProps {}

const SportCoachingForm: FC<SportCoachingFormProps> = ({}) => {
  const [listAdult, setListAdult] = useState<person[]>([]);
  const [listChildren, setListChildren] = useState<person[]>([]);
  const [selectedDay, setSelectedDay] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const onSubmitHandler = useCallback(
    async (data: IFormData) => {
      setIsLoading(true);
      const dataSent = {
        ...data,
        adults: listAdult,
        children: listChildren,
      };

      const dataSubmit = {
        week_days: data.selectedDay.join(', '),
        sport: data.sport,
        preferred_time: data.time,
        adult_count: data.nAdults,
        children_count: data.nChildren,
        special_request: data.special,
        adults: listAdult,
        children: listChildren,
      };

      SportApi.postSportCoaching(dataSubmit)
        .then((value) => {
          Alert.alert('Success', value.data.message);
        })
        .catch((error) => {
          Alert.alert('Error');
        })
        .finally(() => {
          setIsLoading(false);
        });
    },
    [listAdult, listChildren]
  );

  const numberOption = useMemo(() => {
    const data: any[] = [];
    for (let i = 0; i <= 100; i++) {
      data.push({
        label: i.toString(),
        value: i,
      });
    }
    return data;
  }, []);

  const childrenAgeOption = useMemo(() => {
    const data: any[] = [];
    for (let i = 1; i <= 18; i++) {
      data.push({
        label: i.toString(),
        value: i,
      });
    }
    return data;
  }, []);

  const renderForms = useMemo(() => {
    return CoachingFormInputs.map((form, index) => (
      <Field name={form.name} key={form.name}>
        {({ field }: FieldProps) => (
          <View style={{ zIndex: CoachingFormInputs.length - index + 1000 }}>
            <SportDropDown
              items={form.items || []}
              placeholder={form.placeholder}
              title={form.title}
              onChange={(value) => {
                field.onChange(field.name)(value.value.toString());
              }}
              key={form.label}
              horizontal={form.horizontal}
              label={form.label}
            />
            <ErrorMessage
              name={field.name}
              render={(errorMessage: string) => (
                <Text style={{ color: 'red', marginBottom: 10 }}>
                  {errorMessage}
                </Text>
              )}
            />
          </View>
        )}
      </Field>
    ));
  }, []);

  const handleUpdateFormChildren = useCallback(
    (
      length: number,
      setValue: React.Dispatch<React.SetStateAction<person[]>>
    ) => {
      const data: person[] = [];
      for (let i = 1; i <= length; i++) {
        data.push({
          name: '',
          age: '',
        });
      }
      setValue(data);
    },
    []
  );

  return (
    <View>
      <Formik
        initialValues={initValueForm}
        enableReinitialize
        onSubmit={(values, { resetForm }) => {
          onSubmitHandler(values);
        }}
        validationSchema={yup.object().shape({
          selectedDay: yup
            .array()
            .min(1, 'Please Select Weekdays.')
            .of(yup.string()),
          sport: yup.string().required('Please Select sport'),
          time: yup.string().required('Please Select Preferred Time'),
          nAdults: yup.number().required('Please Select No. Of Adults'),
          nChildren: yup.number().required('Please Select No. Of Children'),
          special: yup.string(),
        })}
        // validateOnBlur={true}
      >
        {({
          handleSubmit,
          handleChange,
          values,
          errors,
          setFieldValue,
          touched,
        }) => (
          <View style={{ marginBottom: 30 }}>
            <WeekDaySelect
              selectedDay={values.selectedDay}
              setSelectedDay={(value) => {
                setFieldValue('selectedDay', value, true);
                setSelectedDay(value);
              }}
            />
            {errors.selectedDay && (
              <Text style={{ color: 'red', marginBottom: 10 }}>
                {errors.selectedDay}
              </Text>
            )}
            {/* Render Dropdown group */}
            {renderForms}

            {/* No. Of Adults */}
            <View style={{ zIndex: 102 }}>
              <SportDropDown
                items={numberOption}
                label={'No. Of Adults'}
                title={'Please Select No. Of Adults'}
                onChange={(value) => {
                  handleChange('nAdults')(value.value.toString());
                  handleUpdateFormChildren(value.value as number, setListAdult);
                }}
                horizontal={true}
              />
              {errors.nAdults && touched.nAdults && (
                <Text style={{ color: 'red', marginBottom: 10 }}>
                  {errors.nAdults}
                </Text>
              )}
            </View>
            {listAdult.map((adult, index) => (
              <View style={{ marginBottom: 30 }} key={index}>
                <View style={{ marginBottom: 20 }}>
                  <Text style={styles.textInput}>
                    Name of adult {index + 1}
                  </Text>
                  <View style={styles.inputWrapper}>
                    <TextInput
                      placeholder={`Name of adult ${index + 1}`}
                      onChangeText={(text) => {
                        let newListAdult = [...listAdult];
                        newListAdult[index].name = text;
                        setListAdult(newListAdult);
                        // data.name = text
                      }}
                      value={adult.name}
                      placeholderTextColor={STYLE_VARS.fccDarkGrey}
                      style={styles.formInput}
                    />
                  </View>
                </View>
              </View>
            ))}

            {/* No. Of Children */}
            <View style={{ zIndex: 101 }}>
              <SportDropDown
                items={numberOption}
                label={'No. Of Children'}
                title={'Please Select No. Of Children'}
                onChange={(value) => {
                  handleChange('nChildren')(value.value.toString());
                  handleUpdateFormChildren(
                    value.value as number,
                    setListChildren
                  );
                }}
                horizontal={true}
              />
              {errors.nChildren && touched.nChildren && (
                <Text style={{ color: 'red', marginBottom: 10 }}>
                  {errors.nChildren}
                </Text>
              )}
            </View>

            {listChildren.map((children, index) => (
              <View
                style={{
                  marginBottom: 30,
                  zIndex: listChildren.length - index,
                }}
                key={index}
              >
                <View style={{ marginBottom: 20 }}>
                  <Text style={styles.textInput}>
                    Name of children {index + 1}
                  </Text>
                  <View style={styles.inputWrapper}>
                    <TextInput
                      placeholder={`Name of children ${index + 1}`}
                      onChangeText={(text) => {
                        let newListChildren = [...listChildren];
                        newListChildren[index].name = text;
                        setListChildren(newListChildren);
                      }}
                      value={children.name}
                      placeholderTextColor={STYLE_VARS.fccDarkGrey}
                      style={styles.formInput}
                    />
                  </View>
                </View>
                <View style={{ zIndex: 10 }}>
                  <SportDropDown
                    items={childrenAgeOption}
                    label={`Age of children ${index + 1}`}
                    title={`Age of children ${index + 1}`}
                    onChange={(value) => {
                      let newListChildren = [...listChildren];
                      newListChildren[index].age = value.value.toString();
                      setListChildren(newListChildren);
                    }}
                    horizontal={true}
                  />
                </View>
              </View>
            ))}

            {/* Special Requests */}
            <View style={{ marginBottom: 20, zIndex: 0 }}>
              <Text style={styles.textInput}>Special Requests</Text>
              <View style={styles.inputWrapper}>
                <TextInput
                  placeholder={'Message'}
                  onChangeText={handleChange('special')}
                  value={values.special}
                  textAlignVertical="top"
                  multiline
                  placeholderTextColor={STYLE_VARS.fccDarkGrey}
                  style={styles.formInputMultiple}
                />
              </View>
              {errors.special && (
                <Text style={{ color: 'red' }}>{errors.special}</Text>
              )}
            </View>

            {/* Note text */}
            <View style={{ marginBottom: 20 }}>
              <Text
                style={{
                  color: STYLE_VARS.kccDanger,
                  fontSize: 14,
                  textTransform: 'uppercase',
                  textAlign: 'justify',
                }}
              >
                NOTE: WE WILL REVIEW YOUR SPORTS COACHING BOOKING REQUEST, CHECK
                THE COACHES AVAILABILITY AND GET BACK TO YOU AS SOON AS
                POSSBILE.
              </Text>
            </View>

            {/* Submit Button */}
            <View style={{ alignItems: 'center' }}>
              <Button
                text="SUBMIT BOOKING REQUEST"
                style={STYLE_VARS.blueButton}
                onPress={() => {
                  handleSubmit();
                }}
              />
            </View>
          </View>
        )}
      </Formik>
      {isLoading === true && <Loading isFullScreen={true} />}
    </View>
  );
};

export default SportCoachingForm;

const styles = StyleSheet.create({
  formInputMultiple: {
    height: 100,
    paddingHorizontal: 10,
    alignItems: 'flex-start',
    paddingVertical: 10,
    color: STYLE_VARS.fccDarkerGrey,
    fontSize: 12,
    // textTransform: 'uppercase',
    letterSpacing: 0.8,
    fontWeight: '500',
    fontFamily: FONTS.IowanOldStyleBTRoman,
  },
  inputWrapper: {
    borderWidth: 0.5,
    borderColor: STYLE_VARS.fccDarkGrey,
  },
  formInput: {
    height: 40,
    paddingHorizontal: 5,
    alignItems: 'flex-start',
    paddingVertical: 10,
    color: STYLE_VARS.fccDarkerGrey,
    fontSize: 12,
    letterSpacing: 0.8,
    fontWeight: '500',
    fontFamily: FONTS.IowanOldStyleBTRoman,
  },
  textInput: {
    color: STYLE_VARS.textColor,
    textTransform: 'uppercase',
    fontFamily: FONTS.IowanOldStyleBTRoman,
    fontSize: 13,
    fontWeight: '500',
    marginBottom: 10,
  },
});
